import Vue from 'vue'
import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './assets/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'
import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import App from './App'
import store from './store'
import router from './router'
import permission from './directive/permission'

import './assets/icons' // icon
import './permission' // permission control
import { getAbi } from '@/api/file'
import PageTitle from '@/components/PageTitle'
import PageCard from '@/components/PageCard'
import Account from '@/components/Account'
import VueClipboard from 'vue-clipboard2'
import 'lib-flexible'
if (process.env.VUE_APP_ISMOCK === '1') { // Judge whether it is mock mode
  require('./mock/index.js')
}

// Keep only the ABI helper as a shared runtime entrypoint.
Vue.prototype.getAbi = getAbi

// Keep only components that are still consumed through global registration.
Vue.component('PageTitle', PageTitle)
Vue.component('PageCard', PageCard)
Vue.component('Account', Account)

Vue.use(permission)
Vue.use(VueClipboard)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  locale,
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
